import qs from 'query-string';
import { GLOBAL } from 'saddlebag-browser';
import {
  getDateOffsets,
  floatToPrecisionInt,
  parseAssociateId,
  parseIPAddress,
  pruneEmpty,
} from 'saddlebag-grappler';
import fetch from 'saddlebag-http';
import { logWarn, logOperationalEvent } from 'saddlebag-logger';

import { buildViewData } from './grappler';

const $window = GLOBAL.getWindow();

const SLIPSTREAM_ENDPOINT = '/slipstream';
const SLIPSTREAM_ABSOLUTE_ENDPOINT =
  'https://slipstream.skyscanner.net/slipstream';

const extractParams = (url = $window.location.href) => {
  if (!url) return {};

  const querystring = qs.extract(url);
  const queryParts = querystring.split('&');

  const result = {};
  queryParts.forEach((queryPart) => {
    const part = queryPart.split('=');
    if (!result[part[0]]) {
      // eslint-disable-next-line prefer-destructuring
      result[part[0]] = part[1]; // TODO: Look at using destructuring
    } else if (!result[`${part[0]}__duplicates__`]) {
      result[`${part[0]}__duplicates__`] = [part[1]];
    } else {
      result[`${part[0]}__duplicates__`].push(part[1]);
    }
  });

  return result;
};

const getSlipstreamUrl = (dir, protocol, useAbsoluteUrl = false) => {
  let formattedDir = dir;
  let formattedProtocol = protocol;
  if (!(dir.substring(0, 1) === '/')) {
    formattedDir = `/${dir}`;
  }
  if (!protocol || protocol !== 'https' || protocol !== 'http') {
    formattedProtocol = 'https:';
  }
  if (!(formattedProtocol.substring(formattedProtocol.length - 1) === ':')) {
    formattedProtocol = `${formattedProtocol}:`;
  }
  const endpoint = useAbsoluteUrl
    ? SLIPSTREAM_ABSOLUTE_ENDPOINT
    : SLIPSTREAM_ENDPOINT;

  return `${endpoint}${formattedDir}`;
};

const getInitialOptions = (opts, trackingOpts = {}) => {
  let options = {};
  const currentUrl =
    (opts.redactUrl && opts.redactUrl($window.location.href)) ||
    $window.location.href;

  options = {
    analyticsPageName: opts.analyticsPageName,
    analyticsPageUrl: opts.gaPageView,
    culture: opts.culture,
    currentUrl,
    device: opts.device,
    existingParams: extractParams(currentUrl),
    featureTests: opts.featureTests,
    guid: trackingOpts.guid,
    isInternalUser: opts.isInternalUser,
    page_type: opts.pageType,
    pageInstance: opts.pageInstance,
    virtualReferrer: opts.virtualReferrer,
    requestId: opts.requestId,
    webNode: trackingOpts.WebNode,
  };

  return options;
};

const sendToSlipstream = (data, dir, useAbsoluteUrl = false) => {
  const url = getSlipstreamUrl(dir, undefined, useAbsoluteUrl);
  const serialized = JSON.stringify(data);
  return fetch(url, {
    method: 'POST',
    body: serialized,
  })
    .then((response) => {
      if (!response.ok) {
        logWarn({
          component: 'view-tracking',
          message: `Request to ${url} failed with ${response.status} status`,
          url,
          status: response.status,
        });
      }
    })
    .catch((rejectionReason) => {
      logOperationalEvent({
        eventName: 'sendToSlipstream_fetch_error',
        message: `Fetch failed requesting ${url} with ${rejectionReason}`,
        url,
      });
    });
};

const sendSlipstreamView = (
  utid,
  options,
  authState,
  useAbsoluteUrl = false,
) => {
  const data = buildViewData(options, utid, authState);

  /**
   * This is a temporary change and will be removed once MBD SDK for web is released.
   * For more context please refer here: https://skyscanner.atlassian.net/l/cp/sbtHhBnV
   * Implementation details: https://skyscanner.atlassian.net/l/cp/P7R1HdwJ
   * Motivation: https://skyscanner.atlassian.net/l/cp/CPxyVqGm
   */
  if (data.event_header && data.event_header.guid) {
    // eslint-disable-next-line no-underscore-dangle
    if (!$window.__internal) {
      // eslint-disable-next-line no-underscore-dangle
      $window.__internal = {};
    }
    // eslint-disable-next-line no-underscore-dangle
    $window.__internal.screenViewEventGuid = data.event_header.guid;
  }

  return sendToSlipstream(data, 'view', useAbsoluteUrl);
};

export {
  extractParams,
  getDateOffsets,
  getSlipstreamUrl,
  floatToPrecisionInt,
  parseAssociateId,
  parseIPAddress,
  pruneEmpty,
  getInitialOptions,
  sendToSlipstream,
  sendSlipstreamView,
};
